import React from 'react';

/**
 * Mirrors the real grid cell-for-cell so switching periods never shifts the layout.
 */
const SKELETON_CELLS = [
    'ad-col-hours',
    'ad-col-usage',
    'ad-col-conversations',
    'ad-col-goal',
    'ad-col-performers',
    'ad-col-documents',
    'ad-col-tokens',
    'ad-col-connectors',
];

const DashboardSkeleton: React.FC = () => (
    <div className="ad-grid" aria-busy="true" aria-label="Loading dashboard">
        {SKELETON_CELLS.map((cell) => (
            <div key={cell} className={`ad-card ad-skeleton-card ${cell}`}>
                <div className="ad-skeleton-line ad-skeleton-title" />
                <div className="ad-skeleton-line ad-skeleton-block" />
            </div>
        ))}
    </div>
);

export default DashboardSkeleton;
